import { __decorate, __metadata } from "tslib";
import { DiningOptionEnum, IsUndefinable, LengthWithLVS } from '@goparrot/common';
import { ApiProperty } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsEnum, IsString } from 'class-validator';
import { DiningOptionExposeGroup } from '../interface';
export class CreateDiningOptionPropertyGroupDto {
}
__decorate([
    ApiProperty({ type: () => String, description: 'Dinning option property group label', example: 'TEXTAREA' }),
    Expose({ groups: [DiningOptionExposeGroup.READ, DiningOptionExposeGroup.CREATE, DiningOptionExposeGroup.PATCH, DiningOptionExposeGroup.FIXTURE] }),
    IsUndefinable({ groups: [DiningOptionExposeGroup.PATCH] }),
    IsString({ always: true }),
    LengthWithLVS(1, 250, { always: true }),
    __metadata("design:type", String)
], CreateDiningOptionPropertyGroupDto.prototype, "label", void 0);
__decorate([
    ApiProperty({ enum: DiningOptionEnum, example: DiningOptionEnum.CURBSIDE }),
    Expose({ groups: [DiningOptionExposeGroup.READ, DiningOptionExposeGroup.CREATE, DiningOptionExposeGroup.PATCH, DiningOptionExposeGroup.FIXTURE] }),
    IsUndefinable({ groups: [DiningOptionExposeGroup.PATCH] }),
    IsEnum(DiningOptionEnum, { always: true }),
    __metadata("design:type", String)
], CreateDiningOptionPropertyGroupDto.prototype, "type", void 0);
//# sourceMappingURL=CreateDiningOptionPropertyGroupDto.js.map